import { render } from "./index.vue?vue&type=template&id=358bb888"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-custom-code/federated/index.vue'],['render',render],['__file',"index.vue"]])

export default __exports__